import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectors } from './../../../../../../shared/ducks/customer.duck';
import OrganisationEditForm from './../../../../../shared/containers/OrganisationEditForm';

const getInitialValues = createSelector(
  selectors.data,
  R.applySpec({
    name: R.prop('name'),
    type: R.prop('type'),
    industry: R.prop('industry'),
    sector: R.prop('sector'),
    customerId: R.prop('id'),
  }),
);

const OrganisationCustomerEditForm = connect(state => ({
  initialValues: getInitialValues(state),
}))(OrganisationEditForm);

export default OrganisationCustomerEditForm;
